export const MAPBOX_KEY =
  "pk.eyJ1IjoidHJhY2VhaXIiLCJhIjoiY2ltamh3YnV0MDAxOHZna20zaWNwc2RtOCJ9.hbqrTxObBng34C8NReOMWw";

/* address search */
export const OPENCAGEDATA_ENDPOINT =
  "https://api.opencagedata.com/geocode/v1/geojson";
export const OPENCAGEDATA_KEY = "b0d3bbe7a361fa321befa5a14e6e1fd1";
